export const COUNTRY_STATES = [
  {
    key: '1',
    label: 'AC',
    value: 'ac',
  },

  {
    key: '2',
    label: 'AL',
    value: 'al',
  },

  {
    key: '3',
    label: 'AP',
    value: 'ap',
  },

  {
    key: '4',
    label: 'AM',
    value: 'am',
  },

  {
    key: '5',
    label: 'BA',
    value: 'ba',
  },

  {
    key: '6',
    label: 'CE',
    value: 'ce',
  },

  {
    key: '7',
    label: 'ES',
    value: 'es',
  },

  {
    key: '8',
    label: 'GO',
    value: 'go',
  },

  {
    key: '9',
    label: 'MA',
    value: 'ma',
  },

  {
    key: '10',
    label: 'MT',
    value: 'mt',
  },

  {
    key: '11',
    label: 'MS',
    value: 'ms',
  },

  {
    key: '12',
    label: 'MG',
    value: 'mg',
  },

  {
    key: '13',
    label: 'PA',
    value: 'pa',
  },

  {
    key: '14',
    label: 'PB',
    value: 'pb',
  },

  {
    key: '15',
    label: 'PR',
    value: 'pr',
  },

  {
    key: '16',
    label: 'PE',
    value: 'pe',
  },

  {
    key: '17',
    label: 'PI',
    value: 'pi',
  },

  {
    key: '18',
    label: 'RJ',
    value: 'rj',
  },

  {
    key: '19',
    label: 'RN',
    value: 'rn',
  },

  {
    key: '20',
    label: 'RS',
    value: 'rs',
  },

  {
    key: '21',

    label: 'RO',

    value: 'ro',
  },

  {
    key: '22',
    label: 'DF',
    value: 'df',
  },

  {
    key: '23',
    label: 'RR',
    value: 'rr',
  },

  {
    key: '24',
    label: 'SC',
    value: 'sc',
  },

  {
    key: '25',
    label: 'SP',
    value: 'sp',
  },

  {
    key: '26',
    label: 'SE',
    value: 'se',
  },

  {
    key: '27',
    label: 'TO',
    value: 'to',
  },
]
